import { useSelector } from 'react-redux';
import UICoachingTips from 'ui-coaching-tips/UICoachingTips';
import ForecastTypeSelectorConfig from 'ui-coaching-tips-shared-config/config/forecastTypeSelectorConfig';
import { MIGRATION_COACHING, MIGRATION_TOUR, ONBOARDING_V1, ONBOARDING_V2, ONBOARDING_V2_WITHOUT_MODAL, PORTAL_ACTIVATION, computeTourToDisplay } from '../../utils/tourUtils';
import { ActivationPortalModal } from '../fmo/ActivationPortalModal';
import OnboardingIntroModal from './OnboardingIntroModal';
import ForecastingMigrationModal from '../fmo/ForecastingMigrationModal';
import { useEffectOnlyOnce } from '../../hooks/useEffectOnlyOnce';
import { getContinueSetup } from '../../selectors/additionalQueryParamsSelectors';
import { SET_ADDITIONAL_QUERY_PARAMS } from '../../actions/ActionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const TourSwitch = ({
  dispatch,
  rowData,
  isFmoEnabled,
  isSuperAdmin,
  hasPortalSeenActivationModal,
  hasSeenMigrationTour,
  hasSeenOnboardingV1Tour,
  tourToDisplay,
  setTourToDisplay,
  startTour
}) => {
  const continueSetup = useSelector(getContinueSetup);
  /*
   * Each tour runs an effect that sets the corresponding
   * hasSeen*Tour value to true, which may then cause a different
   * modal to render if this effect were run again. As a result, this effect
   * should only be run once (when row data comes in!).
   */
  useEffectOnlyOnce(() => {
    const tour = computeTourToDisplay({
      isFmoEnabled,
      isSuperAdmin,
      hasPortalSeenActivationModal,
      hasSeenMigrationTour,
      hasSeenOnboardingV1Tour,
      continueSetup
    });
    setTourToDisplay(tour);
    if (tour === ONBOARDING_V2_WITHOUT_MODAL) {
      startTour();
      dispatch({
        type: SET_ADDITIONAL_QUERY_PARAMS,
        payload: {
          continueSetup: false
        }
      });
    }
  }, [rowData], rows => {
    return rows.size > 0;
  });
  switch (tourToDisplay) {
    // OnboardingIntroModal contains logic to pivot on V1 vs V2 depending on FMO gate
    case ONBOARDING_V1:
    case ONBOARDING_V2:
      return /*#__PURE__*/_jsx(OnboardingIntroModal, {});
    case PORTAL_ACTIVATION:
      return /*#__PURE__*/_jsx(ActivationPortalModal, {
        onCloseFunction: startTour
      });
    case MIGRATION_COACHING:
      // We do not need to set hasSeenMigrationTour = true, because Coaching Tips have their own mechanism to only show once
      return /*#__PURE__*/_jsx(UICoachingTips, {
        config: ForecastTypeSelectorConfig
      });
    case MIGRATION_TOUR:
      return /*#__PURE__*/_jsx(ForecastingMigrationModal, {});
    // This case is when the user is still in flow from portal activation - we will start tour without the modal
    case ONBOARDING_V2_WITHOUT_MODAL:
      return null;
    default:
      return null;
  }
};
export default TourSwitch;